package org.braunequip.web.components.forms.Assets

import androidx.compose.runtime.*
import com.varabyte.kobweb.browser.dom.ElementTarget
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaCircleQuestion
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.overlay.Tooltip
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import org.braunequip.web.components.forms.SubmitButton
import org.braunequip.web.components.models.AssetDTO
import org.braunequip.web.components.widgets.ConfirmModal
import org.braunequip.web.util.*
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLSelectElement
import org.w3c.dom.HTMLTextAreaElement
import kotlin.experimental.and

@Composable
fun AdminAssetForm(
    toUpdateAsset: AssetDTO? = null,
    onSubmit: (AssetDTO) -> Unit,
    onDismiss: () -> Unit
) {
    var showConfirmModal by remember { mutableStateOf(false) }
    var errorText by remember { mutableStateOf(" ") }
    var newAssetState by remember(toUpdateAsset) {
        mutableStateOf(
            toUpdateAsset?.copy() ?: AssetDTO()
        )
    }

    LaunchedEffect(Unit) {
        //Necessary for loading default value, and having it still be editable.
        val assetFormTextArea = (document.getElementById(InputIDs.Assets.assetDescription) as HTMLTextAreaElement)
        assetFormTextArea.value = newAssetState.description
    }

    Box(
        modifier = Modifier
            .width(100.vw)
            .height(100.vh)
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .zIndex(19),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = Modifier
                .backgroundColor(Colors.White)
                .borderRadius(20.px)
                .margin(top = 4.cssRem)
                .padding(1.cssRem)
                .zIndex(20)
                .width(min(500.px, 100.percent - 2.cssRem)),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {

                SpanText(
                    text = if (newAssetState.id != null) "ID: ${newAssetState.id}" else "NA",
                    modifier = Modifier
                        .fontSize(1.cssRem)
                        .fontFamily(FONT_FAMILY2)
                )


                FaX(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .onClick {
                            onDismiss()
                        }
                        .color(Colors.Grey)
                )
            }

            /* Specific Form Rows Here */
            H3(
                attrs = Modifier
                    .fillMaxWidth()
                    .textAlign(TextAlign.Start)
                    .color(Colors.Black)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .toAttrs()
            ) {
                Text("Asset Name*")
            }


            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.Assets.assetName)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "Asset Name")
                        attr("value", newAssetState.assetname) // Set value from DTO
                    }
            )

            H3(
                attrs = Modifier
                    .fillMaxWidth()
                    .textAlign(TextAlign.Start)
                    .color(Colors.Black)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .toAttrs()
            ) {
                Text("Equipment Name*")
            }

            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.Assets.equipmentName)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "Equipment Name*")
                        attr("value", newAssetState.equipmentname)
                    }
            )

            H3(
                attrs = Modifier
                    .fillMaxWidth()
                    .textAlign(TextAlign.Start)
                    .color(Colors.Black)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .toAttrs()
            ) {
                Text("Asset Year*")
            }

            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.Assets.assetyear)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "Asset Year")
                        attr("value", newAssetState.year)
                    }
            )

            H3(
                attrs = Modifier
                    .fillMaxWidth()
                    .textAlign(TextAlign.Start)
                    .color(Colors.Black)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .toAttrs()
            ) {
                Text("Asset VIN")
                FaCircleQuestion(
                    modifier = Modifier
                        .margin(left = 6.px)
                        .color(Colors.Black),
                    style = IconStyle.OUTLINE,
                    size = IconSize.SM
                )
            }

            Tooltip(
                target = ElementTarget.PreviousSibling,
                modifier = Modifier
                    .zIndex(21)
                    .width(325.px)
                    .backgroundColor(Colors.WhiteSmoke)
                    .border(1.px, LineStyle.Solid, Colors.Black)
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(0.9.cssRem)
                    .color(Colors.Black)
                    .padding(4.px)
                    .gap(6.px),
            ) {
                Text("If no ERoad ID is supplied, system will use VIN to match record on my.eroad.com, and automatically apply ID. Please ensure this Asset's VIN is accurate.")
            }

            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.Assets.assetvin)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "Asset VIN")
                        attr("value", newAssetState.vin ?: "") // Set value from DTO
                    }
            )

            H3(
                attrs = Modifier
                    .fillMaxWidth()
                    .textAlign(TextAlign.Start)
                    .color(Colors.Black)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .toAttrs()
            ) {
                Text("Vehicle ERoad ID")
                FaCircleQuestion(
                    modifier = Modifier
                        .margin(left = 6.px)
                        .color(Colors.Black),
                    style = IconStyle.OUTLINE,
                    size = IconSize.SM
                )
            }

            Tooltip(
                target = ElementTarget.PreviousSibling,
                modifier = Modifier
                    .zIndex(21)
                    .width(325.px)
                    .backgroundColor(Colors.WhiteSmoke)
                    .border(1.px, LineStyle.Solid, Colors.Black)
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(0.9.cssRem)
                    .color(Colors.Black)
                    .padding(4.px)
                    .gap(6.px),
            ) {
                Text("This ERoad ID will be used to pull relevant data from my.eroad.com. Please ensure it is accurate, or it's information will not be fetched.")
            }

            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.Assets.asseteroadid)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(top = 12.px, bottom = 6.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "ERoad ID")
                        attr("value", newAssetState.eroadId ?: "") // Set value from DTO
                    }
            )

            HorizontalDivider()

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Select(
                    attrs = Modifier
                        .width(48.percent)
                        .height(54.px)
                        .margin(topBottom = 12.px)
                        .padding(leftRight = 20.px)
                        .backgroundColor(Theme.LightGray.rgb)
                        .borderRadius(r = 4.px)
                        .border(
                            width = 2.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .fontFamily(FONT_FAMILY)
                        .fontSize(16.px)
                        .id(InputIDs.Assets.assetType)
                        .toAttrs()
                ) {
                    Option(
                        value = "0",
                        attrs = Modifier
                            .fontFamily(FONT_FAMILY)
                            .fontSize(16.px)
                            .disabled(true)
                            .toAttrs{
                                attr("selected", "true")
                            }
                    ) {
                        Text("Type")
                    }
                    getAssetTypesOptions().forEach { (bitmask, label) ->
                        Option(
                            value = bitmask.toString(),
                            attrs = Modifier
                            .fontFamily(FONT_FAMILY)
                            .fontSize(16.px)
                            .toAttrs{
                                if (newAssetState.type?.let { it and bitmask != 0.toShort() } == true) {
                                    attr("selected", "true") // Mark correct option as selected
                                }
                            }
                        ) {
                            Text(label)
                        }
                    }
                }


                Select(
                    attrs = Modifier
                        .width(48.percent)
                        .height(54.px)
                        .margin(topBottom = 12.px)
                        .padding(leftRight = 20.px)
                        .backgroundColor(Theme.LightGray.rgb)
                        .borderRadius(r = 4.px)
                        .border(
                            width = 2.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .fontFamily(FONT_FAMILY)
                        .fontSize(16.px)
                        .id(InputIDs.Assets.assetStatus)
                        .toAttrs()
                ) {
                    Option(
                        value = "0",
                        attrs = Modifier
                            .fontFamily(FONT_FAMILY)
                            .fontSize(16.px)
                            .disabled(true)
                            .toAttrs{
                                attr("selected", "true")
                            }
                    ) {
                        Text("Status")
                    }
                    getAssetStatusOptions().forEach { (bitmask, label) ->
                        Option(
                            value = bitmask.toString(),
                            attrs = Modifier
                                .fontFamily(FONT_FAMILY)
                                .fontSize(16.px)
                                .toAttrs{
                                    if (newAssetState.status?.let { it and bitmask != 0.toShort() } == true) {
                                        attr("selected", "true") // Mark correct option as selected
                                    }
                                }
                        ) {
                            Text(label)
                        }
                    }
                }
            }

            H3(
                attrs = Modifier
                    .fontFamily(FONT_FAMILY)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .toAttrs()
            ) {
                Text("Miles:")
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Input(
                    type = InputType.Number,
                    attrs = Modifier
                        .id(InputIDs.Assets.assetmiles)
                        .fillMaxWidth()
                        .height(54.px)
                        .margin(topBottom = 12.px)
                        .padding(leftRight = 20.px)
                        .backgroundColor(Theme.LightGray.rgb)
                        .borderRadius(r = 4.px)
                        .border(
                            width = 2.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .fontFamily(FONT_FAMILY)
                        .fontSize(16.px)
                        .toAttrs {
                            attr("placeholder", "Asset Miles Amount")
                            attr("value", newAssetState.miles.toString()) // Set value from DTO
                        }
                )
            }

            TextArea(
                attrs = Modifier
                    .id(InputIDs.Assets.assetDescription)
                    .fillMaxWidth()
                    .height(175.px)
                    .maxHeight(400.px)
                    .margin(top = 8.px)
                    .padding(all = 10.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(4.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .resize(Resize.None)
                    .toAttrs{
                        attr("placeholder", "Brief Description")
                        onInput { event ->
                            newAssetState.description = event.value
                        }
                    }
            )

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {

                SpanText(
                    text = "Created: ${newAssetState.createdAt?.let { formatDate(it) } ?: "NA"}",
                    modifier = Modifier
                        .fontSize(.75.cssRem)
                        .fontFamily(FONT_FAMILY2)
                )
            }

            SpanText(
                modifier = Modifier
                    .width(350.px)
                    .margin(top = 1.cssRem)
                    .fontFamily(FONT_FAMILY2)
                    .color(Colors.Black)
                    .textAlign(TextAlign.Center),
                text = errorText
            )

            SubmitButton(
                text = "SUBMIT",
                onClick = {
                    newAssetState = newAssetState.copy(
                        type = (document.getElementById(InputIDs.Assets.assetType) as HTMLSelectElement).value.toShort(),
                        assetname = (document.getElementById(InputIDs.Assets.assetName) as HTMLInputElement).value,
                        equipmentname = (document.getElementById(InputIDs.Assets.equipmentName) as HTMLInputElement).value,
                        description = (document.getElementById(InputIDs.Assets.assetDescription) as HTMLTextAreaElement).value,
                        status = (document.getElementById(InputIDs.Assets.assetStatus) as HTMLSelectElement).value.toShort(),
                        year = (document.getElementById(InputIDs.Assets.assetyear) as HTMLInputElement).value,
                        vin = (document.getElementById(InputIDs.Assets.assetvin) as HTMLInputElement).value,
                        eroadId = (document.getElementById(InputIDs.Assets.asseteroadid) as HTMLInputElement).value,
                        miles = (document.getElementById(InputIDs.Assets.assetmiles) as HTMLInputElement).value.toIntOrNull() ?: -1
                    )

                    if (
                        newAssetState.assetname.isNotEmpty() &&
                        newAssetState.equipmentname.isNotEmpty() &&
                        (newAssetState.miles >= 0)
                    ) {
                        errorText = " "
                        showConfirmModal = true
                    } else {
                        errorText = "Please fill out all required fields correctly!"
                    }

                }
            )

            if (showConfirmModal) {
                ConfirmModal(
                    actionText = if (toUpdateAsset != null) "Update Asset" else "Submit Asset",
                    onConfirm = {
                        errorText = "Submitted!"
                        onSubmit(newAssetState)
                        showConfirmModal = false
                    },
                    onDismiss = {
                        showConfirmModal = false
                    }
                )
            }
        }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Theme.DarkerGray.rgb)
                .position(Position.Fixed)
                .padding(top = 5.cssRem)
                .onClick {
                    onDismiss()
                }
                .zIndex(19),
            contentAlignment = Alignment.TopCenter
        )
    }
}